import { api } from '../index.js'
import serializer from '../../components/LayoutEditor/serializer'
import { DocumentContainer } from '../../components/LayoutEditor/elements'
// const elements = require('../../components/LayoutEditor/elements')

export default {
  namespaced: true,

  state: {
    templates: [],
    template: {}
  },

  mutations: {
    updateTemplates(state, templates) {
      state.templates = templates
    },

    updateTemplate(state, template) {
      state.template = template
    },

    updateAttribute(state, { attribute, value }) {
      state.template[attribute] = value
    }
  },

  actions: {
    async fetchAll({ commit, state }, active = false) {
      let [templates] = await api.templates.all(active)
      commit('updateTemplates', templates)
      commit('updateTemplate', templates[0])
    },

    async fetchOne({ commit, state }, id) {
      let [template] = await api.templates.one(id)
      // convert POJO to document classes
      template.document = serializer.revive(template.document)
      commit('updateTemplate', template)
    },

    async saveTemplate({ commit, state }) {
      let [template] = await api.templates.save(state.template)
      template.document = serializer.revive(template.document)
      commit('updateTemplate', template)
    },

    newTemplate({ commit, state }) {
      return commit('updateTemplate', {
        name: '',
        description: '',
        document: new DocumentContainer(),
        document_html: '',
        active: false,
        rawMode: false,
      })
    },

    async deleteTemplate({ commit, state }, id) {
      await api.templates.delete(id)
    },

    updateTemplate({ commit, state }, template) {
      commit('updateTemplate', template)
    },

    updateAttribute({ commit, state }, { attribute, value }) {
      commit('updateAttribute', { attribute, value })
    }
  }
}
